import { EntityType } from '@repo/common/enums/entityType';
import { startCase } from 'lodash-es';
import type { ISecodaEntity } from '../../../../api';

export function resourceTypeSecodaText(entity: ISecodaEntity) {
	if (entity.entity_type === EntityType.bi_metric) {
		return 'Metric';
	}

	if (entity.entity_type === EntityType.bi_dashboard) {
		return 'Dashboard';
	}

	if (entity.native_type) {
		return null;
	}

	return startCase(entity.entity_type);
}
